import { useEffect } from 'react';
import { getProvisoUrl } from 'actions/proviso';

/*
* shouldGetProvisoUrl is intentionally NOT in the deps: initialise-proviso must
* fire exactly once per mount and once per retry, never on status changes.
*/
export const useProvisoUrl = ({ dispatch, retryKey, shouldGetProvisoUrl }) => {
  useEffect(() => {
    if (shouldGetProvisoUrl) {
      dispatch(getProvisoUrl());
    }
  }, [dispatch, retryKey]);
};
